import React, { Component } from 'react';
import { Growl } from 'primereact/growl';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Paginator } from 'primereact/paginator';
import servicioArchivos from '../servicios/ServicioArchivos';
import servicioPagos from '../servicios/ServicioPagos';
import Moment from 'react-moment';
import { Button } from 'primereact/button';
import CurrencyFormat from 'react-currency-format';
export class ConsultaComprobantePago extends Component {
    constructor(props) {
        super(props);        
        const { id } = this.props.location.state;
        console.log(id);
        this.state = {
            facturaPadre:{},
            paginacion: {registrosPorPagina: 20
              },
              inicio: 0,
        }
        let {facturaPadre} = this.state;
        facturaPadre.rfcCliente=id.tcReceptor.rfc;
        facturaPadre.ttCfdi =id.ttCfdi;
        facturaPadre.folio =id.ttCfdi.folio;
        facturaPadre.serie = id.ttCfdi.serie;
        facturaPadre.total = id.ttCfdi.total;
        facturaPadre.parcialidad =id.ttCfdi.parcialidad;
        facturaPadre.totalPagado = id.ttCfdi.totalPagado;
        facturaPadre.totalPorPagar = facturaPadre.total - facturaPadre.totalPagado;
        facturaPadre.uuid=id.ttCfdi.uuid;
        facturaPadre.rfcEmisor=id.tcEmisor.rfc;


    }
    componentDidMount() {
        this.obtenerPagina();
    
      }
    cambiaPagina(event) {
        let { paginacion } = this.state;
    
        paginacion.numeroPagina = event.page;
        paginacion.registrosPorPagina = event.rows;
        this.setState({ inicio: event.first, paginacion });
        this.obtenerPagina();
      }
      obtenerPagina() {
        let { paginacion ,facturaPadre} = this.state;
        paginacion.conjunciones = {};
        paginacion.conjunciones['alias_ttCfdi.uuid'] = facturaPadre.ttCfdi.uuid;
        servicioPagos.paginacion(paginacion).then((response) => {
          this.growl.show({ life: 4000, severity: (response.data.error === false ? 'success' : 'error'), summary: '', detail: response.data.mensaje });
    
          if (response.data.error === false)
            this.setState({ paginacion: response.data.objeto });
    
    
        }).catch((error) => {
          if (error)
            return this.growl.show({ life: 4000, severity: 'error', summary: '', detail: 'Lo sentimos, se generó un error no esperado, por favor inténtelo de nuevo más tarde' });
        });
    
      }
      formatofechaCreacion = (rowData, column) => {
        return <Moment format="YYYY-MM-DD HH:mm:ss">
          {rowData.ttCfdi.fechaCreacion}
        </Moment>;
      }
      descargaXmlSaT = (rowData, column) => {

        return <div>
          <div className="p-col-12 p-md-4">
            <Button type="button" icon="pi-md-file-download" className="p-button-success" name="xml"
              tooltip="Descargar xml" onClick={(e) => this.generaDescarga(column.rowData, 'xml')} >
            </Button>
          </div>
        </div>;
      }
      generaDescarga(objeto, tipo) {        
        servicioArchivos.descargaArchivo('/documentos/descargar_documentos.json?uuid=' + objeto.uuid + '&tipo=' + tipo);
    
      }
      descargaRepresentacionImpresa = (rowData, column) => {
        return <div>
          <div>
            <Button type="button" icon="pi-md-file-download" className="p-button-danger" name="pdf"
              tooltip="Descargar pdf" onClick={(e) => this.generaDescarga(column.rowData, 'pdf')} >
            </Button>
          </div>
        </div>;
      }
      columnaEstatus = (rowData, column) => {
        if (rowData.estado === 1)
            return <p>Activo</p>
        if (rowData.estado === 0)
            return <p>Cancelado</p>
    }
    render() {
        const {facturaPadre,paginacion, inicio}=this.state;
        return (
            <div className="content-section implementation">
                <Growl ref={(el) => this.growl = el} />
                <div className="card card-w-title">
                    <h1>Buscar facturas de recepción de pagos</h1>
                </div>
                <div className="card card-w-title">
                <div className="p-grid p-fluid">
              <div className="p-col-12 p-md-3">
                  <h4>Rfc Cliente:</h4>
                  <label htmlFor="input">{facturaPadre.rfcCliente}</label>
                </div>
                <div className="p-col-12 p-md-3">
                <h4>Folio Fiscal:</h4>
                 <label htmlFor="input">{facturaPadre.uuid}</label>
                </div>
                <div className="p-col-12 p-md-3">
                <h4>Folio:</h4>
                <label htmlFor="input">{facturaPadre.folio}</label>
                </div>
                <div className="p-col-12 p-md-3">
                <h4>Serie:</h4>
                <label htmlFor="input">{facturaPadre.serie}</label>
                </div>
                </div>
                <div className="p-grid p-fluid">
              <div className="p-col-12 p-md-3">
                  <h4>Tota General:</h4>
                  <label>
          <CurrencyFormat value={facturaPadre.total} fixedDecimalScale={true} decimalScale={2} displayType={'text'} thousandSeparator={true} prefix={'$'} /></label>
                  
                </div>
                <div className="p-col-12 p-md-3">
                <h4>Total Pagado:</h4>
                <label>
          <CurrencyFormat value={facturaPadre.totalPagado} fixedDecimalScale={true} decimalScale={2} displayType={'text'} thousandSeparator={true} prefix={'$'} /></label>
               
                </div>
                <div className="p-col-12 p-md-3">
                <h4>Total Restante:</h4>
                <label>
                <CurrencyFormat value={facturaPadre.totalPorPagar} fixedDecimalScale={true} decimalScale={2} displayType={'text'} thousandSeparator={true} prefix={'$'} /></label>
                
                </div>
                <div className="p-col-12 p-md-3">
                <h4>No. Parcialidades Realizadas:</h4>
                <label htmlFor="input">{facturaPadre.parcialidad}</label>
                </div>
                <div className="p-col-12 p-md-3">
                <h4>No. Parcialidad Actual:</h4>
                <label htmlFor="input">{facturaPadre.parcialidad}</label>
                </div>
                </div>
                <DataTable value={paginacion.datos} editable={true} scrollable={true} scrollHeight="280px"  >
           
                <Column header="Descarga Pdf" body={this.descargaRepresentacionImpresa.bind(this)} style={{ width: '100px' }} />
            <Column header="Descarga Xml" body={this.descargaXmlSaT.bind(this)} style={{ width: '100px' }} autoLayout={true} />
            <Column field="uuid" header="Folio fiscal" style={{ width: '200px' }} filter={false} autoLayout={true} />
            <Column field="folio" header="Folio" style={{ width: '200px' }} filter={false} autoLayout={true} />
            <Column field="serie" header="Serie" style={{ width: '200px' }} filter={false} autoLayout={true} />
            <Column field="fechaCreacion" body={this.formatofechaCreacion} header="Fecha Creacion" style={{ width: '200px' }} filter={false} autoLayout={true} />
            

          </DataTable>
          <Paginator first={inicio} rows={paginacion.registrosPorPagina} totalRecords={paginacion.registrosTotales} onPageChange={this.cambiaPagina.bind(this)} rowsPerPageOptions={[20, 40, 60, 80, 100]} />
                
                </div>
            </div>
        );
    }
}